import { useContext, useEffect, useState } from 'react'
import { Column, Row } from 'react-table'
import Table from '../../../global/components/table/Table'
import BasicFilter from '../../../global/components/table/helpers/filters/BasicFilter'
import CheckboxFilter from '../../../global/components/table/helpers/filters/CheckboxFilter'
import LocationFilter from '../../../global/components/table/helpers/filters/LocationFilter'
import { handleColumnFilterUpdate } from '../../../global/components/table/helpers/multiColumnFilters'
import { ITechnician } from '../../../../../app/entities/Technician'
import { UserContext } from '../../../base/components/base-container/BaseContainer'
import { PERMISSIONS } from '../../../global/constants/permissions'
import hasPermission from '../../../global/utils/user/has-permission'
import fetchDataAndSetTable from '../../../global/components/table/helpers/fetchDataAndSetTable'

interface ITechnicianTableProps {
  setOpen: Function
}

function TechniciansTable(props: ITechnicianTableProps) {

  const { user } = useContext(UserContext)

  const [tableState, setTableState] = useState({
    data: [] as ITechnician[],
    isLoading: false,
    pageSize: 100,
    offSet: 0,
    count: 0,
  })

  // Default to showing only active technicians
  const [showActiveOnly, setShowActiveOnly] = useState(true)
  const [locationColumnFilter, setLocationColumnFilter] = useState('')
  const [columnFilters, setColumnFilters] = useState({ inactive: 'false' })

  const isTechEditDisabled = !hasPermission(user).allow(
    PERMISSIONS.TECHNICIANS.CATEGORY,
    PERMISSIONS.TECHNICIANS.ENTRIES.EDIT_TECHNICIANS.NAME,
  )
  const techniciansTableEndpoint = `${process.env.REACT_APP_ORIGIN}/technicians`

  function onColumnFilterUpdate(filtersUpdate: object) {
    handleColumnFilterUpdate(filtersUpdate, columnFilters, setColumnFilters)
  }

  function retrieveTableData() {
    fetchDataAndSetTable<ITechnician>({
      endpoint: techniciansTableEndpoint,
      queries: [
        { columnFilters: JSON.stringify(columnFilters) },
        { pageSize: tableState.pageSize.toString() },
        { offSet: tableState.offSet.toString() },
      ],
      setTableState,
    })
  }

  useEffect(() => {
    retrieveTableData()
  }, [tableState.pageSize, tableState.offSet, columnFilters])

  function handleActiveFilterChange(checked: boolean) {
    setShowActiveOnly(checked)
    onColumnFilterUpdate({ inactive: checked ? 'false' : '' })
  }

  function handleLocationFilterChange(value: string) {
    setLocationColumnFilter(value)
    onColumnFilterUpdate({ location: value ? { name: value } : '' })
  }

  const columns: Column<ITechnician | any>[] = [
    {
      Header: 'Employee ID',
      accessor: 'employeeId',
      Filter: BasicFilter({
        onEnter: (val: string) => onColumnFilterUpdate({ employeeId: val }),
      }),
    },
    {
      Header: 'Samsara ID',
      accessor: 'samsaraId',
      Filter: BasicFilter({
        onEnter: (val: string) => onColumnFilterUpdate({ samsaraId: val }),
      }),
    },
    {
      Header: 'Technician',
      accessor: 'name',
      Filter: BasicFilter({
        onEnter: (val: string) => onColumnFilterUpdate({ name: val }),
      }),
    },
    {
      Header: 'Active',
      accessor: (data: any) => {
        const { inactive } = data
        return inactive ? 'Inactive' : 'Active'
      },
      Filter: CheckboxFilter({
        checked: showActiveOnly,
        onChange: handleActiveFilterChange,
      }),
    },
    {
      Header: 'Location',
      accessor: 'location.name',
      Filter: LocationFilter({
        value: locationColumnFilter,
        onChange: handleLocationFilterChange,
      }),
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <Table
        columns={columns}
        data={tableState.data ?? []}
        isLoading={tableState.isLoading}
        onRowClick={
          isTechEditDisabled
            ? () => {}
            : (row: Row) => {
                const original = row.original as ITechnician

                props.setOpen({
                  isOpen: true,
                  techId: original.objectId,
                })
              }
        }
        isPaginated
        pagination={{ setTableState, tableState }}
        isTableTopperPresent={false}
      />
    </div>
  )
}

export default TechniciansTable
